import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID =
  (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined) || "G-SDFMX0KR39";

let initialized = false;

const hasGaMeasurementId = (): boolean => {
  return typeof GA_MEASUREMENT_ID === "string" && GA_MEASUREMENT_ID.trim().length > 0;
};

export const initAnalytics = (): void => {
  if (initialized || !hasGaMeasurementId()) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
  initialized = true;
};

export const trackPageView = (path: string): void => {
  if (!hasGaMeasurementId()) return;
  if (!initialized) initAnalytics();
  ReactGA.send({ hitType: "pageview", page: path });
};
